import React, { Component } from "react"
import PropTypes from "prop-types"

import BoutonAcheterTirage from "./BoutonAcheterTirage"

import { locales } from "../../../locales"
import { objetEstDefini } from "../../js/client-es/utils"
import {
  PrestationsTirage,
  rechercherFinition,
} from "../../js/client-es/boutique"
import BoutonInformations from "../boutons/BoutonInformations"

export default class SelectionFinition extends Component {
  constructor(props) {
    super(props)
    this.prestationsTirage = new PrestationsTirage(
      this.props.image,
      this.props.langue
    )
    this.prixMinimal = props.image[this.props.langue].tirage.prix_minimal
    this.state = {
      prix: `${this.prixMinimal}`,
      aPartirDe: `${locales[this.props.langue].boutique.aPartirDe}`,
    }
    this.refSelectDimension = React.createRef()
    this.refSelectFinition = React.createRef()
    this.callbackFocusSurExplications = props.callbackFocusSurExplications
  }

  render() {
    return (
      <div id="boutique-selection-finition">
        <label htmlFor="choix-dimension">
          1. {locales[this.props.langue].boutique.dimensions} :
        </label>
        <form id="boutique-selection-finition-form">
          <select
            id="choix-dimension"
            onChange={this.selectionDimension.bind(this)}
            ref={this.refSelectDimension}
            required={true}
          >
            <option value="">
              {locales[this.props.langue].boutique.selectionnezUneDimension}
            </option>
            {this.prestationsTirage.dimensions.map(dimension => {
              return (
                <option value={dimension.code} key={dimension.code}>
                  {dimension.texte}
                </option>
              )
            })}
          </select>
          <span>
            <label htmlFor="choix-finition">
              2. {locales[this.props.langue].boutique.finition} :
            </label>
            <BoutonInformations
              classeCSS="galerie-tirage-conteneur-bouton-informations"
              langue={this.props.langue}
              traitementAAppelerSurClick={this.callbackFocusSurExplications}
            />
          </span>
          <select
            id="choix-finition"
            onChange={this.selectionFinition.bind(this)}
            ref={this.refSelectFinition}
            required={true}
          >
            <option value="">
              {locales[this.props.langue].boutique.selectionnezUneFinition}
            </option>
            {this.creerItemsFinitions()}
          </select>
          <div id="boutique-selection-finition-conteneur-prix">
            <span>{this.state.aPartirDe} </span>
            <span id="boutique-selection-finition-prix">
              {this.obtenirTextePrix(this.state.prix, this.props.langue)}
            </span>
            {this.obtenirTextePoint()}
          </div>
          <div>
            <BoutonAcheterTirage
              image={this.props.image}
              langue={this.props.langue}
              finition={this.obtenirFinitionSelectionnee()}
              prestations={this.prestationsTirage}
            />
          </div>
        </form>
      </div>
    )
  }

  selectionDimension(e) {
    if (e.target.value !== "") {
      this.setState({
        dimensionSelectionnee: e.target.value,
        finitionSelectionnee: undefined,
      })
    } else {
      this.setState({
        finitionSelectionnee: undefined,
        aPartirDe: `${locales[this.props.langue].boutique.aPartirDe}`,
        prix: `${this.prixMinimal}`,
      })
      this.refSelectFinition.current.value = ""
    }
  }

  obtenirPremiereFinitionPourDimension(idDimension) {
    return this.prestationsTirage.finitions[idDimension][0]
  }

  selectionFinition(e) {
    if (e.target.value !== "") {
      const finitionSelectionnee = rechercherFinition(
        this.prestationsTirage.finitions,
        e.target.value
      )
      this.setState({
        aPartirDe: "",
        finitionSelectionnee: finitionSelectionnee,
        prix: finitionSelectionnee.prix,
      })
    } else {
      this.setState({
        finitionSelectionnee: undefined,
        aPartirDe: `${locales[this.props.langue].boutique.aPartirDe}`,
        prix: `${this.prixMinimal}`,
      })
    }
  }

  obtenirPremiereDimension() {
    return this.prestationsTirage.dimensions[0].code
  }

  obtenirFinitionSelectionnee() {
    return objetEstDefini(this.state.finitionSelectionnee)
      ? this.state.finitionSelectionnee
      : undefined
  }

  creerItemsFinitions() {
    if (
      objetEstDefini(this.refSelectDimension.current) &&
      this.refSelectDimension.current.value !== ""
    ) {
      return this.prestationsTirage
        .rechercherFinitionsPourUneDimension(this.state.dimensionSelectionnee)
        .map(finition => {
          return (
            <option key={finition.code} value={finition.code}>
              {finition.texte}
            </option>
          )
        })
    } else return null
  }

  obtenirTextePoint() {
    if (objetEstDefini(this.state.finitionSelectionnee)) {
      return ""
    } else return "."
  }

  obtenirTextePrix(prix, langue) {
    return locales[langue].boutique.prix.replace("{0}", prix)
  }
}

SelectionFinition.propTypes = {
  image: PropTypes.object,
  langue: PropTypes.string,
  tarifsTirage: PropTypes.object,
  callBackSelectionTarif: PropTypes.func,
  callbackFocusSurExplications: PropTypes.func,
}
